import React from "react";
import {Grid} from "@leap4/frontend";
import {EntitiesProperties} from "../../../utils/enums";
import {SingleMetric} from "../../common/OverviewGeneralInfo/SingleMetric";
import {IMetricsTotals} from "../../../interfaces/IOverviewData";

export interface IHomePageGeneralInfoProps {
    data: IMetricsTotals
}

export const HomeGeneralInfo = ({data}: IHomePageGeneralInfoProps): JSX.Element => {
    const {SPENT, IMPRESSIONS, REQUESTS, FILL_RATE} = EntitiesProperties.NUMERIC.ALL
    const displayData = data ? {
        spent: data.cost,
        impressions: data.impressions,
        requests: data.requests,
        fillRate: data.fillRate
    } : {};

    const metricEnumKeyMap = {
        spent: SPENT,
        impressions: IMPRESSIONS,
        requests: REQUESTS,
        fillRate: FILL_RATE,
    }
    return (
        <Grid container direction={"row"} justifyContent={"space-evenly"} alignItems={"center"} sx={{ py: 0.5, px: 2 }}>
            {Object.entries(displayData)?.map(([metricKey, metricValue]) => {
                return (
                    <Grid key={metricKey} sx={{ textAlign: 'center', flex: 1 }}>
                        <SingleMetric
                            metricValue={metricValue as number} metricEnum={metricEnumKeyMap[metricKey]}
                        />
                    </Grid>
                )
            })}
        </Grid>
    )
}
